import React, { useEffect, useState } from 'react'
import { Button, Modal, Checkbox, Row, Col, Input, message, Spin } from 'antd';
import { auditCase } from "@/api";
import './index.less';
const plainOptions = ['内容老旧', '重复案例', '图片拍摄视角不佳', '图片不清晰', '图片过曝', '图片色调过暗', '图片存在明显水印', '含售卖信息/电话/二维码/QQ号', '含竞争对手广告', '存在违规内容', '其他'];
export default (props) => {
  const { examinationFailedVisible, setExaminationFailedVisible, offShelf, caseId, setVisible, handleQuery, handleNext } = props
  const [value, setValue] = useState('');
  const [checkedValues, setCheckedValues] = useState([]);
  const [loading,setLoading] = useState();
  // const { run,data, error, loading} = useRequest(auditCase)

  const { TextArea } = Input;
  const onCancel = () => {
    setLoading(false)
    setExaminationFailedVisible(false)
    setCheckedValues([])
    setValue('')
  }
  const onChange = (checkedValues) => {
    console.log('checked = ', checkedValues);
    setCheckedValues(checkedValues)
  };

  // 审核
  const goAuditCase = async () => {
    setLoading(true);
    try {
      const remark = checkedValues.join(',') + `${value ? ':' + value : ''}`
      const params = {
        caseId,
        remark,
        type: offShelf ? 1 : 2 //1:下载 2:审核不通过
      }
      if(handleNext){
        handleNext()
      }

      // setVisible(false)
      const res = await auditCase(params)
      // run(params)
      if (res.error.errorCode == 0) {
        message.success('成功')
        onCancel()
        handleQuery()
      } else {
        message.error(res.error.errorMsg);
      }
    } catch (error) { }
  }
  return (
    <Modal
      centered
      destroyOnClose
      wrapClassName='examinationFailedModal'
      width={300}
      visible={examinationFailedVisible}
      onCancel={onCancel}
      closable={false}
      footer={
        <Button disabled={(checkedValues.length && !checkedValues.includes('其他')) || (checkedValues.includes('其他') && value) ? false : true} type='primary' onClick={goAuditCase}>
          {offShelf ? '确认下架' : '确认拒绝'} {loading ? <Spin  /> : ''}
        </Button>
      }
    >
      <Checkbox.Group options={plainOptions} defaultValue={[]} onChange={onChange} />
      <TextArea
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder=""
        autoSize={{
          minRows: 3,
          maxRows: 5,
        }}
      />
    </Modal>
  )
}
